module.exports = __webpack_public_path__ + "img/北京中医药大学东方医院.cf0ac6be.png";